module.exports = __webpack_public_path__ + "img/logo-big.a1cd75d1.jpg";